module.exports = __webpack_public_path__ + "static/media/283.aa73d72e.wav";